// src/Dashboard/pages/teacher/SuiviCompetitions/components/CompetitionRegisteredAdherentsFilters.jsx

import React from "react";
import { FaFilter, FaTimes, FaUsers } from "react-icons/fa";

export default function CompetitionRegisteredAdherentsFilters({
  filters,
  setFilters,
  ageCategories = [],
  birthYears = [],
  total = 0,
  filteredCount = 0,
}) {
  const hasActiveFilters = !!filters.ageCategory || !!filters.birthYear;

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetFilters = () => {
    setFilters({
      ageCategory: "",
      birthYear: "",
    });
  };

  return (
    <div className="mb-4 rounded-[22px] border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter className="text-indigo-500" />
            Filtrer les inscrits
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Pratique pour préparer les pesées par catégorie d’âge et année de
            naissance.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-xs font-bold text-slate-700 ring-1 ring-slate-200 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700">
            <FaUsers />
            {filteredCount} / {total}
          </span>

          {hasActiveFilters && (
            <button
              type="button"
              onClick={resetFilters}
              className="inline-flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-xs font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-100 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
            >
              <FaTimes />
              Réinitialiser
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Catégorie d’âge
          </label>

          <select
            value={filters.ageCategory}
            onChange={(event) =>
              updateFilter("ageCategory", event.target.value)
            }
            className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="">Toutes les catégories</option>

            {ageCategories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Année de naissance
          </label>

          <select
            value={filters.birthYear}
            onChange={(event) => updateFilter("birthYear", event.target.value)}
            className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="">Toutes les années</option>

            {birthYears.map((year) => (
              <option key={year} value={String(year)}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}